// Import React and Hooks
import React, { useEffect } from 'react'
// Import Redux and Hooks
import { Dispatch } from 'redux'
import { useAppDispatch } from './../../hooks/useRedux'
// Import Actions
import { playSoundAction } from '../../actions/generalAction'
import { toCreateOfferingButton, toShowOfferingButton } from '../../actions/datalayer'
// Import Components
import Button from './Button'
import DownloadButton from './DownloadButton'



// Launch Box Prop
interface launchBoxProp {
  additionalClass?:string,
  launchBoxData: {
    title:string,
    subtitle:string
  }
}

const LaunchBox = ( { additionalClass, launchBoxData }:launchBoxProp ) => {



  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  // Handle play
  function handlePlay( willPlayed:boolean, buttonClic: number ) {
    buttonClic == 1 ? toCreateOfferingButton() : ( buttonClic == 2 && toShowOfferingButton() )
    dispatch( playSoundAction( willPlayed ) )
  }



  // Use effect
  useEffect( () => {
    window.startAnimation()
  }, [] )



  return (
    <section className={`launchBox ${ additionalClass ? additionalClass : ''}`}>
      <div className="launchBox__container">
        <div className="launchBox__left">

          <div
            id="animation_container"
            className='launchBox__canvasWrapper' >
            <canvas
              id="canvas"
              width="650"
              height="650" />
            <div
              id="dom_overlay_container" />
          </div>

        </div>
        <div className="launchBox__right">
          <h1
            className="launchBox__title mb25 mbM15"
            dangerouslySetInnerHTML={{ __html: launchBoxData.title }} />
          <h2
            className="launchBox__text mb40"
            dangerouslySetInnerHTML={{ __html: launchBoxData.subtitle }} />
          <div className="launchBox__buttons">
          <Button
            url="/cempasuchil/crear-ofrenda"
            additionalClass="m10 mM5 mbM15"
            type="animated"
            functionClick={ () => handlePlay( true, 1 ) }
            text="Crea tu ofrenda" />
          <Button
            url="/cempasuchil/ofrendas-vivas"
            additionalClass="btn--default m10 mM5"
            functionClick={ () => handlePlay( true, 2 ) }
            text="Ver ofrendas" />
          {/* <DownloadButton text='Descargar lata' /> */}
          </div>
        </div>
      </div>
    </section>
  )
}



export default LaunchBox
